import React from 'react';
import styled from 'App/styled';
import { useTheme } from 'emotion-theming';


interface PriceInfoProps {
  priceInfo: (
    {
      discount: number;
      mrp: number;
      offerPrice: number;
    }
    | undefined
  )
}


const Wrap = styled.div`
  ${({ theme }) => theme.typography.bodyLarge};
  color: #8c8d94;
`;


const SlashedPrice = styled.span`
  text-decoration: line-through;
  display: inline-block;
  margin: 0 4px;
  ${({ theme }) => theme.typography.bodyMedium};
`;


const OfferPrice = styled.span`
  display: inline-block;
  ${({ theme }) => theme.typography.titleXSmall};
  margin: 0 4px;
  color: #3f414d;
`;


interface DiscountProps {
  color: string;
}

const Discount = styled.span`
  display: inline-block;
  margin: 0 8px;
  ${({ theme }) => theme.typography.subTitleMedium};
  color: ${({ color }: DiscountProps) => color};
  border-left: 1px solid #ebebeb;
  margin-left: 8px;
  padding-left: 8px;

`;


const Price = ({
  priceInfo,
}: PriceInfoProps) => {
  const {
    discount,
    mrp,
    offerPrice,
  } = priceInfo || {};
  const theme: Theme = useTheme();

  return (
    <Wrap>
      {
        (mrp && offerPrice && (mrp > offerPrice)) ? (
          <>
            <SlashedPrice>
              {`₹${mrp}`}
            </SlashedPrice>
            <OfferPrice>
              {`₹${offerPrice}`}
            </OfferPrice>
            {(!!discount) && (
              <Discount color={theme.colors.positive}>
                {`${discount}% off`}
              </Discount>
            )}
          </>
        ) : (
          <OfferPrice>
            {`₹${mrp}`}
          </OfferPrice>
        )
      }
    </Wrap>
  );
};


export default Price;
